module.exports = __webpack_public_path__ + "assets/img/floorplan-btm-logo.e15972a3.png";